// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { slideShowArrowStyles } from "@guestsupply/App/Components/SlideShowArrow/SlideShowArrow";
import { color } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

slideShowArrowStyles.arrowStyle = {
    css: css`
        &:disabled > ${IconWrapper} {
            color: ${color("text.main", 0.33)};
        }
        &:hover:not(:disabled) > ${IconWrapper} {
            color: ${color("common.ui8", 1)};
        }
        ${IconWrapper}, svg {
            width: 8px;
            height: 14px;
        }
    `,
};
